import React, { useEffect, useState, useRef } from "react"
import { Alert, Card, Col, Container, Row } from "react-bootstrap"
import { CSSTransition } from "react-transition-group"
import { useParams, useNavigate } from "react-router-dom"
import { fetchAPIData, isLoggedIn, notAuthorized } from "../../api/AuthService"
import { DefaultKeys, FETCH_SML, SMLKeys } from "../../constant/Constants"
import CustomTable from "../commonComponents/CustomTable"
import { errorHandling, handleClick, pdfData } from "../commonComponents/EventHandler"
import HeaderComponent from "../commonComponents/HeaderComponent"
import PdfDownloadComponent from "../commonComponents/PdfDownloadComponent"
import SideNav from "../commonComponents/SideNav"
import SingleColumnAttributes from "../commonComponents/SingleColumnAttributes"
import TopContent from "./SmlTopContent"

function SmlAllinfo(props) {
   const { objectID, searchId, partName } = useParams()
                     const navigate = useNavigate()
   const [data, setData] = useState({
      headerContent: {},
      attributeObject: {},
      smartLabelRow: [],
      whereUsed: null,
   })

   const [loading, setLoading] = useState(true)
   const searchData = searchId || objectID

   const parentName = localStorage.getItem("parentName")
   const parentRev = localStorage.getItem("parentRev")
   const parentState = localStorage.getItem("parentState")

   const [sideNav, setSideNav] = useState()
   const [inProp, setInProp] = useState(false)
   const nodeRef = useRef(null)
   const [selectedItems, setSelectedItems] = useState(DefaultKeys)
   const [pdfDataSet, setPdfDataSet] = useState({})

   const handleSelectedItems = (obj, IsFilterView) => {
      setSelectedItems(obj)
      var values = pdfData(data, obj, IsFilterView)
      setPdfDataSet(values)
   }

   useEffect(() => {
      const fetchState = { cancel: false }
      if (!isLoggedIn()) {
         navigate("/")
      } else {
         async function fetchSmlData(fetchState) {
            try {
               setLoading(true)
               setInProp(true)
               setSideNav("")
               var apiData

               if (
                  !partName &&
                  sessionStorage.getItem(searchData) &&
                  sessionStorage.getItem(searchData) !== ""
               ) {
                  apiData = JSON.parse(sessionStorage.getItem(searchData))
               } else {
                  // Load async data from an Fpp Api endpoint.
                  const response = await fetchAPIData(`${FETCH_SML}/${searchData}${partName ? `/${partName}` : ''}`)
                  apiData = response.data
                  if (apiData.headerContentObject)
                     if (!partName) sessionStorage.setItem(searchData, JSON.stringify(response.data))
               }

               if (fetchState.cancel) {
                  return
               }
               setData((data) => ({
                  ...data,

                  headerContent: apiData.headerContent
                     ? apiData.headerContent
                     : data.headerContent,
                  attributeObject: apiData.Properties,
                  smartLabelRow: apiData.smartLabelRow,
                  whereUsed: apiData.whereUsed,
               }))
               setLoading(false)
               setNavigation()
            } catch (error) {
               // setError(error)
               if (error.response && error.response.data.status === 401) {
                  console.log("Error", ` Not authorie: ${error}`)
                  notAuthorized(navigate)
                  return
               }
               console.log("Error", ` API request failed: ${error}`)
               setLoading(false)
               errorHandling(error, navigate)
            }
         }
         window.scrollTo(0, 0)
         fetchSmlData(fetchState)
      }

      return () => {
         fetchState.cancel = true
      }
   }, [searchData, navigate])

    useEffect(() => {
                        if (!loading && data.headerContent && data.headerContent?.Name) {
                          
                           const timer = setTimeout(() => {
                              
                              setNavigation()
                           }, 1000) // Increased from 100ms to 1000ms
                           return () => clearTimeout(timer)
                        }
                     }, [selectedItems, loading])

   return (
      <React.Fragment>
         <HeaderComponent name={partName ? decodeURIComponent(partName) : data.headerContent?.Name} pdfDataSet={pdfDataSet} />
         <CSSTransition timeout={300} in={inProp} classNames="my-node" nodeRef={nodeRef}>
            <Container fluid ref={nodeRef}>
               <Row>
                  <Col sm="3" md="2" className="leftSection">
                     <br />
                     <Col sm="3" md="2" className="labels sideNav">
                        {!loading && data.headerContent && data.headerContent?.Name && (
                           <div>
                              <p style={{ marginLeft: "15px" }}>
                                 Name : {data.headerContent?.Name} <br />
                                 Revision : {data.headerContent?.Revision}
                              </p>
                              {sideNav && (
                                 <SideNav
                                    data={sideNav}
                                    handler={handleSelectedItems}
                                    resData={data}
                                    Keys={SMLKeys}
                                    Name={data.headerContent?.Name}
                                    searchData={searchData}
                                    Revision={data.headerContent?.Revision}
                                    whereUsed={data.whereUsed}
                                 />
                              )}
                           </div>
                        )}
                     </Col>
                  </Col>
                  <Col sm="9" md="10" id="print" className="contentBackground">
                     <br />
                     {!loading && data.headerContent && data.headerContent?.Name ? (
                        <Row id="data">
                           <Col md="9" sm="9">
                              <TopContent
                                 headerContent={data.headerContent}
                                 parentName={parentName}
                                 parentRev={parentRev}
                                 parentState={parentState}
                              />
                           </Col>
                           <Col md="3" sm="3" align="right">
                              <PdfDownloadComponent
                                 pdfDataSet={pdfDataSet}
                                 genDocHide={searchId ? true : false}
                                 pdfHide={true}
                              />
                           </Col>
                        </Row>
                     ) : (
                        !loading && (
                           <div>
                              <Alert variant="info">
                                 <p style={{ marginLeft: "30rem" }}>
                                    {" "}
                                    No data available to show.
                                 </p>
                              </Alert>
                           </div>
                        )
                     )}
                     <br />
                     <Row>
                        <Col md="12" className="dataCol contentBackground">
                           {data.attributeObject && selectedItems["attributeObject"] && (
                              <div>
                                 <Card autoFocus>
                                    <Card.Body
                                       className="accordionStyle"
                                       onClick={handleClick.bind(this, "0", "zero")}
                                       aria-controls="zero"
                                    >
                                       {SMLKeys.attributeObject}{" "}
                                       <i
                                          id="0"
                                          name="accordItem"
                                          className="fa fa-minus-circle accordIconStyle"
                                       ></i>
                                    </Card.Body>
                                 </Card>
                                 <div
                                    className="accordionDiv shadow"
                                    id="zero"
                                    name="collapseItem"
                                    style={{ display: "block" }}
                                 >
                                    <SingleColumnAttributes
                                       loading={loading}
                                       data={data.attributeObject}
                                    />
                                 </div>
                              </div>
                           )}
                           {!loading &&
                              data.smartLabelRow &&
                              data.smartLabelRow?.length > 0 &&
                              selectedItems["smartLabelRow"] && (
                                 <div>
                                    <Card>
                                       <Card.Body
                                          className="accordionStyle"
                                          onClick={handleClick.bind(this, "1", "one")}
                                          aria-controls="one"
                                       >
                                          {SMLKeys.smartLabelRow}{" "}
                                          <i
                                             id="1"
                                             name="accordItem"
                                             className="fa fa-minus-circle accordIconStyle"
                                          ></i>
                                       </Card.Body>
                                    </Card>
                                    <div
                                       className="accordionDiv shadow"
                                       id="one"
                                       name="collapseItem"
                                       style={{ display: "block" }}
                                    >
                                       <CustomTable data={data.smartLabelRow} />
                                    </div>
                                 </div>
                              )}
                              {!loading &&
                              data.whereUsed !== null &&
                              selectedItems["whereUsed"] && (
                                 <div style={{ display: "none" }}>
                                    <Card>
                                       <Card.Body
                                          className="accordionStyle"
                                          onClick={handleClick.bind(
                                             this,
                                             "36",
                                             "thirtysix"
                                          )}
                                          aria-controls="thirtysix"
                                       >
                                          {SMLKeys.whereUsed}{" "}
                                       </Card.Body>
                                    </Card>
                                    <div
                                       id="thirtysix"
                                       name="collapseItem"
                                       style={{ display: "none" }}
                                    ></div>
                                 </div>
                              )}
                        </Col>
                     </Row>
                  </Col>
               </Row>
            </Container>
         </CSSTransition>
      </React.Fragment>
   )
   function setNavigation() {
   requestAnimationFrame(() => {
      requestAnimationFrame(() => {
         setTimeout(() => {
            const sideNavObj = document.getElementsByClassName("accordionStyle")
            if (sideNavObj && sideNavObj.length > 0) {
               for (let i = 0; i < sideNavObj.length; i++) {
                  const text = sideNavObj[i].innerText.trim().split('\n')[0]
               }
               const sideNavArray = Array.from(sideNavObj)
               setSideNav(sideNavArray)
            }
         }, 500)
      })
   })
}
}
export default SmlAllinfo